<template>
	<div class="headboxdeom" el-table v-loading="loading" element-loading-text="加载中"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 1, 39, 0.8)">
		<div class="head">
			<!-- 上部分标题部分 -->
			<div class="headbody">
				<el-container>
					<!-- 上部分内容部分 -->
					<el-header height='160px'>
						<div class="upper">
							<el-row>
								<el-col :span="12">
									<div class="time" >
										{{currenttim}} {{weekday}}
										
									</div>
								</el-col>
								<el-col :span="12">
									<div class="button" >
										<el-row>
											<!-- <el-col :span="8">
												<div style="width: 100px;text-align: center;">
													<img src="../assets/return.png"/>
												</div>
											</el-col> -->
											<el-col :span="12">
												<div style="width: 100px;text-align: center;">
													<img src="../assets/home.png" />
												</div>
											</el-col>
											<el-col :span="12">
												<div style="width: 100px;text-align: center;" @click="gethomeurl()">
													<img src="../assets/screen.png" />
												</div>
											</el-col>
										</el-row>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-header>
					<!-- 下部分内容部分 -->
					<el-main>
						<div class="lower">
							<el-row>
								<!-- 左边第一块内容 -->
								<el-col :span="6">
									<div class="container">
										<!-- ↓↓↓↓↓↓↓↓↓↓人大代表组织在线 ↓↓↓↓↓↓↓↓↓↓↓↓-->
										<div class="containerone">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="16">
														<div style="display: flex;">
														<div class="tieletextonelok">人大组织在线 </div>
														<div class="tieletextcol">总人数:</div>
														<div class="textupcorl">
															2105
														</div>
														<!-- 2120 -->
														<div class="tieletextcol">人</div>
														</div>
													</el-col>
													<el-col :span="4">
														<div class="subtitle" @click="overview()">查看详情</div>
													</el-col>
												</el-row>

											</div>
											<div class="leveliocbox">
												<div class="levelioc">
													<div class="textup">
														2
													</div>
													<div class="textdw">
														全国
													</div>
												</div>
												<div class="levelioc">
													<div class="textup">
														5
													</div>
													<div class="textdw">
														山东省
													</div>
												</div>
												<div class="levelioc" @click="cscscs()">
													<div class="textup">
														120
													</div>
													<div class="textdw">
														枣庄市
													</div>
												</div>
												<div class="levelioc">
													<div class="textup">
														439
													</div>
													<div class="textdw">
														滕州市
													</div>
												</div>
												<div class="levelioc">
													<div class="textup">
														1539
													</div>
													<div class="textdw">
														镇街
													</div>
												</div>
											</div>
											<div class="leveliocboxone">
												<div class="leveCarousel">
													<dv-scroll-board @click="getMethod" :config="cesi"
														style="width:65px;height:100px" ref="nationwide" />
												</div>
												<div class="leveCarousel">
													<dv-scroll-board @click="getMethod" :config="config"
														style="width:65px;height:100px" ref="economize" />
												</div>
												<div class="leveCarousel">
													<dv-scroll-board @click="getMethod" :config="config"
														style="width:65px;height:100px" ref="market" />
												</div>
												<div class="leveCarousel">
													<dv-scroll-board @click="getMethod" :config="config"
														style="width:65px;height:100px" ref="county" />
												</div>
												<div class="leveCarousel">
													<dv-scroll-board @click="getMethod" :config="config"
														style="width:65px;height:100px" ref="zhenjie" />
												</div>
											</div>
										</div>
										<!-- ↑↑↑↑↑↑↑↑↑人大代表组织在线结束↑↑↑↑↑↑↑↑↑ -->
										<div class="containertwo">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">代表风采</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle" @click="ckdbfc()">查看详情</div>
													</el-col>
												</el-row>
											</div>
											<div class="rotationtable">
												<el-carousel indicator-position="none" :interval="4000" type="card"
													height="165px">
													<el-carousel-item v-for="item in Image">
														<img style="width: 100%;height: 100%;" :src="item.img" />
													</el-carousel-item>
												</el-carousel>
											</div>
										</div>
										<div class="containerthree">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">惠民实事在线</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle" @click="ckhmss()">查看详情</div>
													</el-col>
												</el-row>
												<div class="rotationtiele">

												</div>
												<div class="rotationtiele">
													<el-row :gutter="20">
														<el-col :span="6">
															项目名称
														</el-col>
														<el-col :span="6">
															市级领导
														</el-col>
														<el-col :span="6">
															责任委室
														</el-col>
														<el-col :span="6">
															进度%
														</el-col>
													</el-row>
												</div>
												<div>
													<dv-scroll-board :config="benefit" style="width:460px;height:105px"
														name='hmss' ref="scroll-Board" @click="gethmssurl" />
												</div>
											</div>

										</div>
										<div class="containerfour">
											<el-row>
												<el-col :span="12">
													<div class="typeimg">
														<img class="typeimgcss" src="../assets/annualreport.png" />
													</div>
												</el-col>
												<el-col :span="12">
													<div class="typeimg" style="display: flex;justify-content: right;">
														<img class="typeimgcss" src="../assets/study.png" />
													</div>
												</el-col>
											</el-row>
											<div style="margin-top: 24px;">
												<el-row>
													<el-col :span="12">
														<div class="typeimg">
															<img class="typeimgcss" src="../assets/official.png"
																@click="official()" />
														</div>
													</el-col>
													<el-col :span="12">
														<div class="typeimg"
															style="display: flex;justify-content: right;">
															<img class="typeimgcss" src="../assets/convergence.png"
																@click="convergence()" />
														</div>
													</el-col>
												</el-row>
											</div>
										</div>

									</div>
								</el-col>
								<!-- <div class="mapsimg"/> -->
								<div class="mapsimg"  @click="getmaps()()"/> 
								<!-- 这个是地图点 -->
								<div class="mapcss">
									<div class="tuli" v-for="item,index in heading" :key="index">
										<el-row>
											<el-col :span="4">
												<div style="display: flex;justify-content: center;margin-top: 9px;">
													<el-image style="width: 16px; height: 18px"
														:src="item.img"></el-image>
												</div>
											</el-col>
											<el-col :span="11">
												<div
													style="font-size: 12px;color: #fff;width: 100%;line-height:34px;text-align:left;">
													{{item.tit}}
												</div>
											</el-col>
											<el-col :span="9">
												<div style="height: 34px;">
													<div style="text-align: center;line-height: 34px;display: flex;">
														<div style="color: #fff;">(</div>
														<div class="textsunzi">{{item.siz}}
														</div>
														<div style="color: #fff;">)</div>
													</div>
												</div>
											</el-col>
										</el-row>
									</div>
								</div>
								<!-- 中间部分内容 -->
								<el-col :span="12">
									<div class="middle">
										<div class="middleboxone" >
											<div class="contanier" v-drag id="lBox" @mousewheel="scaleDom">
												<div class="maplikebox">
													<div class="mapstit"
														style="width: 80px;height: 170px;margin-left: 150px;top: 170px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		滨湖镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：12个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 100px;height: 120px;margin-left: 236px;top: 160px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		大坞镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 80px;height: 100px;margin-left: 336px;top: 105px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		界河镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：9个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 70px;height: 110px;margin-left: 436px;top: 90px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		龙阳镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 100px;height: 160px;margin-left: 524px;top: 55px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		东郭镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：15个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 60px;height: 100px;margin-left: 524px;top: 235px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		东沙河街道
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：7个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 40px;height: 60px;margin-left: 472px;top: 255px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		龙泉街道
																		<div style="font-size: 14px;">
																			宪法文化广场：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表之家：2个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：8个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 20px;height: 100px;margin-left: 418px;top: 218px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		荆河街道

																		<div style="font-size: 14px;">
																			代表之家：2个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 90px;height: 30px;margin-left: 434px;top: 218px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		北辛街道
																		<div style="font-size: 14px;">
																			代表联络总站：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：7个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 60px;height: 120px;margin-left: 335px;top: 218px;border-radius: 40px;transform: rotate(20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		姜屯镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 130px;height: 80px;margin-left: 220px;top: 330px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		级索镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联络站：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：9个
																		</div>
																		<div style="font-size: 14px;">
																			代表工作室：6个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 100px;height: 30px;margin-left: 360px;top: 340px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		洪绪镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联络站：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：7个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 30px;height: 50px;margin-left: 458px;top: 310px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		善南街道
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：6个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 60px;height: 80px;margin-left: 487px;top: 342px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		南沙河镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：7个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 50px;height: 115px;margin-left: 560px;top: 335px;border-radius: 40px;transform: rotate(15deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		木石镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联络站：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：7个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 50px;height: 165px;margin-left: 640px;top: 335px;border-radius: 40px;transform: rotate(15deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		羊庄镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>

																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 60px;height: 75px;margin-left: 500px;top: 435px;border-radius: 40px;transform: rotate(-15deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		官桥镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>

																		<div style="font-size: 14px;">
																			代表联系点：8个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 130px;height: 50px;margin-left: 500px;top: 525px;border-radius: 40px;transform: rotate(-25deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		柴胡店镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联络站：1个
																		</div>
																		<div style="font-size: 14px;">
																			代表联系点：6个
																		</div>
																		<div style="font-size: 14px;">
																			代表工作室：2个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 50px;height: 140px;margin-left: 430px;top: 470px;border-radius: 40px;transform: rotate(-20deg);">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		张汪镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>

																		<div style="font-size: 14px;">
																			代表联系点：11个
																		</div>

																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 80px;height: 90px;margin-left: 395px;top: 375px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		鲍沟镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>

																		<div style="font-size: 14px;">
																			代表联系点：10个
																		</div>
																		<div style="font-size: 14px;">
																			代表工作室：1个
																		</div>
																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
													<div class="mapstit"
														style="width: 150px;height: 50px;margin-left: 240px;top: 420px;border-radius: 40px;">
														<el-popover placement="right" trigger="hover">
															<div style="width:100% ;height:200px;">
																<div class="boximg">
																	<div style="font-size: 20px;font-weight: 600;">
																		西岗镇
																		<div style="font-size: 14px;">
																			代表之家：1个
																		</div>

																		<div style="font-size: 14px;">
																			代表联系点：8个
																		</div>

																	</div>
																</div>
															</div>
															<div style="width: 100%;height: 100%;" slot="reference" />
														</el-popover>
													</div>
												</div>
											</div>
										</div>


										<div class="middletwo">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">重点工作在线</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle" @click="ckjdgz()">查看详情</div>
													</el-col>
												</el-row>
											</div>
											<div class="focuscss">
												<div class="textone">
													重点项目进度
												</div>
												<div class="texttwo">
													108
												</div>
												<div class="textone">
													项
												</div>
												<div class="schedule">
													<el-progress :text-inside="true" :color='customColors'
														:stroke-width="26" :percentage="89"></el-progress>
												</div>
												<div
													style="color: #fff; line-height: 57px;font-size: 12px;display: flex;">
													<img style="width: 20px;margin-top: 20px;margin-left: 8px;"
														src="../assets/red.png" />
													<div> 完成</div>
													<img style="width: 20px;margin-top: 20px;margin-left: 8px;"
														src="../assets/green.png" />
													<div> 进展顺利</div>
												</div>
											</div>

											<div>
												<div
													style="width: 100%;height: 40px;display: flex;justify-content: center;margin-top: 10px;">
													<div
														style="font-size: 18px;color: #ffffff;line-height: 40px;width: 100px;font-weight: 600;">
														序号
													</div>
													<div
														style="font-size: 18px;color: #ffffff;line-height: 40px;width: 420px;font-weight: 600;">
														重点工作
													</div>
													<div
														style="font-size: 18px;color: #ffffff;line-height: 40px;width: 160px;font-weight: 600;">
														分管领导
													</div>
													<div
														style="font-size: 18px;color: #ffffff;line-height: 40px;width: 60px;font-weight: 600;">
														进度
													</div>
												</div>
											</div>
											<div class="boxhmss">
												<dv-scroll-board @click="getzdgzurl" :config="supervise"
													ref="scrollBoard" style="width:732px;height:100px" name='hmss' />
											</div>
										</div>
									</div>
								</el-col>
								<!-- 右边部分内容 -->
								<el-col :span="6">
									<div class="rightbox">
										<div class="rightone">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">善意履职</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle" @click="nathead()">[第十九届]</div>
													</el-col>
												</el-row>

											</div>
											<div class="rightimg">
												<div class="imgboxone">
													<el-row>
														<el-col :span="7">
															<div class="tieletext" />
														</el-col>
														<el-col :span="8">
															<div class="yian">
																议案建议数
															</div>
														</el-col>
														<el-col :span="9">
															<div class="yiansiz">
																328
															</div>
														</el-col>
													</el-row>
												</div>
												<div class="imgboxtwo">
													<el-row>
														<el-col :span="7">
															<div class="tieletext" />
														</el-col>
														<el-col :span="8">
															<div class="yian">
																履职次数
															</div>
														</el-col>
														<el-col :span="9">
															<div class="yiansiz">
																5253
															</div>
														</el-col>
													</el-row>
												</div>
											</div>
										</div>
										<div class="righttwo" @click="liu()">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">“六个一”主题实践活动</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle">查看详情</div>
													</el-col>
												</el-row>

											</div>
											<div id="main"
												style="width: 460px;height:280px !important;margin-top: -30px;" />
										</div>
										<div class="rightthree" @click="getslurl()">
											<!-- 表头 -->
											<div class="title">
												<el-row>
													<el-col :span="2">
														<div class="ioc"></div>
													</el-col>
													<el-col :span="14">
														<div class="tieletext">善意双联</div>
													</el-col>
													<el-col :span="6">
														<div class="subtitle">查看详情</div>
													</el-col>
												</el-row>
											</div>
											<div class="rotationtiele">
												<el-row :gutter="20">
													<el-col :span="4">
														组别
													</el-col>
													<el-col :span="10">
														<div style="text-align: center;">
															参加人员
														</div>
													</el-col>
													<el-col :span="9">
														<div style="text-align: right;">
															联系代表小组
														</div>
													</el-col>
												</el-row>
											</div>
											<dv-scroll-board :config="duplex" ref="duplexlist"
												style="width:100%;height:110px" name='sysl' />
										</div>
										<div class="rightfour">
											<el-row>
												<el-col :span="12">
													<div class="titlelift" @click="expertone()">
														<el-row>
															<el-col :span="4">
																<div class="ioc"></div>
															</el-col>
															<el-col :span="9">
																<div class="tieletext">善意专家</div>
															</el-col>
														</el-row>
													</div>
												</el-col>
												<el-col :span="12">
													<div class="titlerright" @click="meeting()">
														<el-row>
															<el-col :span="4">
																<div class="ioc"></div>
															</el-col>
															<el-col :span="9">
																<div class="tieletext">善智会议</div>
															</el-col>
														</el-row>
													</div>
												</el-col>
											</el-row>
											<div v-show="apparent">
												<div style="display: flex;">
													<div id="option"
														style="width: 200px;height:205px !important;margin-top: -0px;" />
													<div style="width: 260px;height:205px !important;margin-top: 0px;">
														<el-row>
															<el-col :span="12">
																<div style="width:100%;height: 195px;margin-top: 12px;">
																	<div v-for="item in legend"
																		style="color: #fff;border-bottom: 1px dashed #fff;width: 85%;height: 42px;text-align: center;">
																		<div
																			style="display: flex;justify-content: left;">
																			<img style="width: 15px;height: 15px;margin-top: 15px;"
																				:src="item.img" />
																			<div
																				style="text-align: center;line-height: 44px;margin-left: 4px;font-size: 12px;">
																				{{item.tit}}ᅟ{{item.siz}}
																			</div>
																		</div>
																	</div>
																</div>
															</el-col>
															<el-col :span="12">
																<div style="width:100%;height: 195px;margin-top: 12px;">
																	<div v-for="item in legenddata"
																		style="color: #fff;border-bottom: 1px dashed #fff;width: 85%;height: 42px;text-align: center;">
																		<div
																			style="display: flex;justify-content:left;">
																			<img style="width: 15px;height: 15px;margin-top: 15px;"
																				:src="item.img" />
																			<div
																				style="text-align:left;line-height: 44px;margin-left: 4px;font-size: 12px;">
																				{{item.tit}}ᅟ{{item.siz}}
																			</div>
																		</div>
																	</div>
																	<div
																		style="color: #55ffff;width: 85%;height: 96px;text-align: center;">
																		<div style="height: 48px;line-height:50px;">
																			专家总人数</div>
																		<div class="boxzhuanjiasiz">{{this.expertzong}}
																		</div>
																	</div>
																</div>
															</el-col>
														</el-row>
													</div>
												</div>

											</div>

											<div v-if="hide">
												<div>
													<el-row>
														<el-col :span="8">
															<div class="congress">
																<div>市人大会议</div>
																<div class="congresstext">{{this.meetingdata[0].value}}
																</div>
															</div>
														</el-col>
														<el-col :span="8">
															<div class="congress">
																<div>常委会会议</div>
																<div class="congresstext">{{this.meetingdata[1].value}}
																</div>
															</div>
														</el-col>
														<el-col :span="8">
															<div class="congress">
																<div>党组会议</div>
																<div class="congresstext">{{this.meetingdata[2].value}}
																</div>
															</div>
														</el-col>
													</el-row>
													<el-row>
														<el-col :span="8">
															<div class="congress">
																<div>主 任 会 议 </div>
																<div class="congresstext">{{this.meetingdata[3].value}}
																</div>
															</div>
														</el-col>
														<el-col :span="8">
															<div class="congress">
																<div>理论学习组</div>
																<div class="congresstext">{{this.meetingdata[4].value}}
																</div>
															</div>
														</el-col>
														<el-col :span="8">
															<div class="congress">
																<div>党建会议</div>
																<div class="congresstext">{{this.meetingdata[5].value}}
																</div>
															</div>
														</el-col>
													</el-row>
												</div>
												<div>
													<el-row>
														<el-col :span="24">
															<div class="congressbox">
																<div class="congresstextone">
																	<div>机关全体人员会议</div>
																	<div class="congresstext">0</div>
																</div>
															</div>
														</el-col>
													</el-row>
												</div>
											</div>
										</div>
									</div>
								</el-col>
							</el-row>


						</div>
					</el-main>
				</el-container>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import axios from 'axios';
	import {
		getport
	} from '@/api/api'
	export default {
		data() {
			return {
				name: 'app',

				loading: true,
				apparent: true,
				hide: false,
				expert: [],
				meetingdata: [],
				expertzong: '',
				nationwide: [],
				economize: [],
				market: [],
				county: [],
				zhenjie: [],
				time: '',
				weekday: '',
				currenttim: '',
				liugeyi: [],
				cscs: [13, 13, 13, 13, 13, 13],
				legend: [{
					img: require('@/assets/1.png'),
					tit: '农村农业类',
					siz: ''
				}, {
					img: require('@/assets/2.png'),
					tit: '教科文卫类',
					siz: ''
				}, {
					img: require('@/assets/3.png'),
					tit: '社会建设类',
					siz: ''
				}, {
					img: require('@/assets/4.png'),
					tit: '检查司法类',
					siz: ''
				}],
				legenddata: [{
					img: require('@/assets/5.png'),
					tit: '财经经济类',
					siz: ''
				}, {
					img: require('@/assets/6.png'),
					tit: '建环保护类',
					siz: ''
				}],
				heading: [{
					img: require('@/assets/zz.png'),
					tit: '代表联络总站',
					siz: '1个'
				}, {
					img: require('@/assets/whgc.png'),
					tit: '宪法文化广场',
					siz: '1个'
				}, {
					img: require('@/assets/zj.png'),
					tit: '代表之家',
					siz: '23个'
				}, {
					img: require('@/assets/llz.png'),
					tit: '代表联络站',
					siz: '7个'
				}, {
					img: require('@/assets/lxd.png'),
					tit: '代表联系点',
					siz: '177个'
				}, {
					img: require('@/assets/gzs.png'),
					tit: '代表工作室',
					siz: '9个'
				}],
				cesi: {
					rowNum: '4',
					data: [],
					align: ['left'],
					columnWidth: [99, 1],
					oddRowBGC: 'transparent',
					evenRowBGC: '#004681',
				},
				config: {
					rowNum: '4',
					data: [],
					align: ['left'],
					columnWidth: [99, 1],
					align: ['center'],
					oddRowBGC: 'transparent',
					evenRowBGC: '#004681',
				},
				duplex: {
					rowNum: '4',
					data: [
						[
							"一组",
							"朱晏辰  贾福军  陈振成  孟凡尧 侯宜敏  司增会  贾礼亚  董  冰",
							"柴胡店  北  辛 荆  河"
						],
						[
							"二组",
							"刘  茜  钟  敏  夏学衍  赵逢柏 徐  亚  颜振华  赵月振",
							"大坞  南沙河 东沙河  机  关"
						],
						[
							"三组",
							"马  冀  龙琳洲  孙茂胜  陈凡国 陈  杰  刘  渠  魏朝廷  李敬",
							"鲍沟、姜屯、张汪、善南"
						],
						[
							"四组",
							"孙  剑  王印德  周茂林  马兆国  马灿阶  魏  华  刘明月  ",
							"滨  湖  东  郭 级  索  龙  阳"
						],
						[
							"五组",
							"孔凡华  朱绍邦  王正平  朱瑞国 司国光  李  艳  陈子君",
							"官  桥  界  河  木  石  龙  泉"
						],
						[
							"六组",
							"马兆鹏  刘玉洋  王式田  袁  春 姜广涛  张宗端  杨位民  马卉茹",
							"洪  绪  西  岗  羊  庄  工  信"
						],
					],

					columnWidth: [90, 240, 140],
					oddRowBGC: 'rgba(0, 42, 88, 1.0)',
					evenRowBGC: 'transparent',
				},
				benefit: {
					rowNum: '4',
					data: [],
					columnWidth: [120, 120, 130, 80, 0],
					oddRowBGC: 'rgba(0, 42, 88, 1.0)',
					evenRowBGC: 'transparent',
				},
				supervise: {
					rowNum: '3',
					data: [],
					columnWidth: [90, 430, 160, 60, 0],
					oddRowBGC: 'rgba(0, 42, 88, 1.0)',
					evenRowBGC: 'transparent',
				},
				Image: [],
				customColors: [{
						color: '#f56c6c',
						percentage: 20
					},
					{
						color: '#e6a23c',
						percentage: 40
					},
					{
						color: '#5cb87a',
						percentage: 60
					},
					{
						color: '#1989fa',
						percentage: 80
					},
					{
						color: '#6f7ad3',
						percentage: 100
					}
				]

			}
		},
		// 自定义指令 —— 拖动div
		directives: {
			drag(el) {
				let oDiv = el // 当前元素
				// let self = this // 上下文
				// 禁止选择网页上的文字
				document.onselectstart = function() {
					return false
				}
				oDiv.onmousedown = function(e) {
					// 鼠标按下，计算当前元素距离可视区的距离
					let disX = e.clientX - oDiv.offsetLeft
					let disY = e.clientY - oDiv.offsetTop
					document.onmousemove = function(e) {
						// 通过事件委托，计算移动的距离
						let l = e.clientX - disX
						let t = e.clientY - disY
						// 移动当前元素
						oDiv.style.left = l + 'px'
						oDiv.style.top = t + 'px'
					}
					document.onmouseup = function(e) {
						document.onmousemove = null
						document.onmouseup = null
					}
					// return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
					return false
				}
			}
		},
		created() {
			this.getUser()
			this.gettime()
			this.getkeynote()
			this.gethmss()
			this.getlgy()
			this.getimgurl()
			// 专家
			this.getzhuanjia()
			// 地图
			this.getmapsiz()
			// 会议
			this.getmeeting()
		},
		mounted() {

		},
		methods: {
			
			scaleDom() {
				let div = document.getElementById("lBox");
				let scale = parseFloat((div.style.transform || `scale(1)`).replace(/[^0-9.]/gi, ''))
				let size = event.wheelDelta / 1200;
				scale += size;
				if (scale >= 0.5) div.style.transform = `scale(${scale})`;
			},
			//人大代表点击进入宜搭详情页面
			getMethod(value) {
				var data = value.row[1]
				window.open(
					"https://fs4qpg.aliwork.com/s/daibiao_detail?id=" + data,
					"_self");
			},
			//点击进入宜搭重点工作详情页面
			getzdgzurl(value) {
				// console.log(value.row[4])
				var data = value.row[4]
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-K5766HA10YP9QRCE9MSGZA82WQ233IZML0FGLS?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&wybs=" +
					data,
					"_self");
			},
			//点击进入宜搭惠民实事详情页面
			gethmssurl(value) {
				// console.log(value.row[4])
				var data = value.row[4]
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-JD8668C1Y0AAP7U6BOWMS6YPSD6S3UMFD1ZGL7?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&formInstId=" +
					data,
					"_self");
			},
			ckhmss() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-WY766581H1Z42TP6FOEKU85BK1AZ1TRY86W9LP1?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			ckjdgz() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-08866RA185P9ZBA6CEGUE9JEAZ6G3MRWHXEGLX?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			ckdbfc() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-0IA66C71WA7AUPXG990GP8UL2XZ921TWRMUGL2?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			cscscs() {
				window.open(
					"https://fs4qpg.aliwork.com/s/daibiao_detail?id=FINST-CP766Q81XGN5JJ09F1ZN7CACUQSV2V4T5MHALDUL",
					"_self");
			},
			getslurl() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-MP966K81F97AZFUNARN1U9ZZMXZN3DHANKAHL7?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			// 融媒体在线
			convergence() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-D2B665D1U21AG3LV94EKA5NY0PPH26C0V4MGL7?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			// 办公在线
			official() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-K5A66M71A5Q98ZWKD68KI9IYCQUD3OWI1MLGLJ2?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85",
					"_self");
			},
			getimgurl() {
				for (var i = 1; i < 19; i++) {
					var imga = 'https://rdscreen.wkyyds.xyz/upload/' + i + '.jpg'
					const img = {
						img: imga
					}
					this.Image.push(img)
				}
			},
			mapup() {

			},
			nathead() {
				this.$router.replace({
					path: 'head'
				});
			},
			getmaps(){
				this.$router.replace({
					path: 'map'
				});
			},
			liu() {
				this.$router.replace({
					path: 'six'
				});
			},
			overview() {
				this.$router.replace({
					path: 'overview'
				});
			},
			gethomeurl() {
				window.open("https://fs4qpg.aliwork.com/s/tz_work_home", "_self");
			},
			// 专家会议显隐
			expertone() {
				this.apparent = true
				this.hide = false
			},
			// 专家会议显隐
			meeting() {
				this.apparent = false
				this.hide = true
			},
			//获取善智会议
			getmeeting() {
				let path = '?id=13'
				getport('', path).then(res => {
					this.meetingdata = res.data
					console.log(this.meetingdata)
				})
			},
			// 重点工作
			getkeynote() {
				let path = '?id=3'
				getport('', path).then(res => {
					const scrollBoard = this.$refs['scrollBoard']
					
					
					
					var zhongdian = res.data
					
					function transformTaskStatus(zhongdian) {
					  // 深拷贝原数据（避免修改原数组），这里针对数组结构简化深拷贝
					  return zhongdian.map(item => {
					    // 复制子数组的每一项
					    const newItem = [...item];
					    // 根据索引3的值替换状态
					    switch (newItem[3]) {
					      case "1":
					        newItem[3] = "完成";
					        break;
					      case "0":
					        newItem[3] = "进展顺利";
					        break;
					      // 若有其他值，保持原样
					      default:
					        break;
					    }
					    return newItem;
					  });
					}
					
					const transformedData = transformTaskStatus(zhongdian);
					
					console.log(transformedData,'555');
					scrollBoard.updateRows(transformedData)
				})
			},
			//获取惠民事实
			gethmss() {
				let path = '?id=2'
				getport('', path).then(res => {
					const scrollBoard = this.$refs['scroll-Board']
					scrollBoard.updateRows(res.data)
				})
			},
			// 获取六个一柱状图数量
			getlgy() {
				let path = '?id=4'
				getport('', path).then(res => {
					let arr = res.data.filter(item => {
						return item == "解决一个实际问题"
					}).map(item => {
						return item
					})
					let arra = res.data.filter(item => {
						return item == "接受一次述职评议"
					}).map(item => {
						return item
					})
					let arrb = res.data.filter(item => {
						return item == "提出一条建议"
					}).map(item => {
						return item
					})
					let arrc = res.data.filter(item => {
						return item == "参加一次调研"
					}).map(item => {
						return item
					})
					let arrd = res.data.filter(item => {
						return item == "接待一次选民"
					}).map(item => {
						return item
					})
					let arre = res.data.filter(item => {
						return item == "联系一个村或一个重点项目"
					}).map(item => {
						return item
					})
					this.cscs = '[' + arre.length + ',' + arrd.length + ',' + arrc.length + ',' + arrb.length +
						',' + arr.length + ',' + arra.length + "]"
					setTimeout(this.myEcharts(), 2000);
					console.log(this.cscs)
					// 调用Echarts

				})
			},
			// 获取专家数量
			getzhuanjia() {
				let path = '?id=11'
				getport('', path).then(res => {
					this.expert = res.data
					this.legend[0].siz = res.data[0].value
					this.legend[1].siz = res.data[1].value
					this.legend[2].siz = res.data[2].value
					this.legend[3].siz = res.data[3].value
					this.legenddata[0].siz = res.data[4].value
					this.legenddata[1].siz = res.data[5].value
					this.expertzong = res.data[0].value + res.data[1].value + res.data[2].value + res.data[3]
						.value + res.data[4].value + res.data[5].value
					console.log(this.expertzong)
					this.myEcharts()
				})
			},
			// 获取地图点数量
			getmapsiz() {
				let path = '?id=12'
				getport('', path).then(res => {
					this.heading[0].tit = res.data[0].tit
					this.heading[0].siz = res.data[0].siz + '个'
					this.heading[1].tit = res.data[1].tit
					this.heading[1].siz = res.data[1].siz + '个'
					this.heading[2].tit = res.data[2].tit
					this.heading[2].siz = res.data[2].siz + '个'
					this.heading[3].tit = res.data[3].tit
					this.heading[3].siz = res.data[3].siz + '个'
					this.heading[4].tit = res.data[4].tit
					this.heading[4].siz = res.data[4].siz + '个'
					this.heading[5].tit = res.data[5].tit
					this.heading[5].siz = res.data[5].siz + '个'
				})
			},
			// 获取人大代表
			getUser() {
				let path = '?id=96'
				getport('', path).then(res => {
					const scrollBoard = this.$refs['nationwide'].updateRows(res.data)
					let path = '?id=97'
					getport('', path).then(res => {
						const scrollBoard = this.$refs['economize'].updateRows(res.data)
						let path = '?id=98'
						getport('', path).then(res => {
							const scrollBoard = this.$refs['market'].updateRows(res.data)
							this.loading = false
							let path = '?id=99'
							getport('', path).then(res => {
								const scrollBoard = this.$refs['county'].updateRows(res
									.data)
								let path = '?id=100'
								getport('', path).then(res => {
									const scrollBoard = this.$refs['zhenjie'].updateRows(res.data)
								})
							})
						})
					})
				})
			},
			//echats配置
			myEcharts() {
				var myChart = echarts.init(document.getElementById('main'));
				// 绘制柱状图表
				myChart.setOption({
					xAxis: {
						type: 'category',
						data: ['联系一个村或重点项目', '接待一次选民', '参加一次调研', '提出一条建议', '解决一个实际问题', '接受一次述职评议'],
						axisLabel: {
							show: true,
							color: '#ffffff',
							fontSize: 12,
							interval: 0,
							width: 30,
							overflow: "breakAll"
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},

					},
					yAxis: {
						type: 'value',
						axisLabel: {
							show: true,
							color: '#ffffff',
							fontSize: 12,

						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								// type: 'dashed', //默认实线，dashed虚线
								width: 1,
								color: '#082592',
							}
						},
					},
					series: [{
						name: '六个一', //系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列。
						type: 'bar',
						itemStyle: { //
							normal: {

								color: new echarts.graphic.LinearGradient(
									0, 0, 0, 1,
									[{
											offset: 0,
											color: '#FFD800'
										},
										{
											offset: 0.5,
											color: '#00C0FF'
										},
										{
											offset: 1,
											color: '#0078FF'
										}
									]
								),

								barBorderRadius: [6, 6, 6, 6]
							},

						},
						barWidth: '40%',
						data: JSON.parse(this.cscs)
					}]
				})

				var myChart = echarts.init(document.getElementById('option'));
				// 绘制柱状图表
				myChart.setOption({
					legend: {
						left: 'center',
						top: 'bottom',
						data: [
							'rose1',
							'rose2',
							'rose3',
							'rose4',
							'rose5',
							'rose6',
							'rose7',
							'rose8'
						]
					},
					toolbox: {
						show: true,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: false,
								readOnly: false
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: false
							}
						}
					},
					series: [{
							name: 'Radius Mode',
							type: 'pie',
							radius: [30, 70],
							center: ['50%', '58%'],
							roseType: 'radius',
							itemStyle: {
								borderRadius: 5
							},
							label: {
								show: false
							},
							// emphasis: {
							// 	label: {
							// 		show: true,
							// 		position: 'center',
							// 		textStyle: { //数值样式
							// 			color: '#00FFD7',
							// 			fontSize: 12
							// 		}
							// 	}
							// },
							data: this.expert,
						},

					]
				})
			},
			// 获取当前时间
			gettime() {
				let time = new Date()
				// 获取当前星期
				var week = time.getDay()
				if (week == 0) {
					this.weekday = '星期天'
					console.log(this.weekday)
				} else if (week == 1) {
					this.weekday = '星期一'
					console.log(this.weekday)
				} else if (week == 2) {
					this.weekday = '星期二'
					console.log(this.weekday)
				} else if (week == 3) {
					this.weekday = '星期三'
					console.log(this.weekday)
				} else if (week == 4) {
					this.weekday = '星期四'
					console.log(this.weekday)
				} else if (week == 5) {
					this.weekday = '星期五'
					console.log(this.weekday)
				} else if (week == 6) {
					this.weekday = '星期六'
					console.log(this.weekday)
				}
				this.currenttim = getNowFormatDate()
				// console.log(getNowFormatDate(),) //  2022 年 06 月 22 日 time
				// 获取当前日期时间封装
				function getNowFormatDate() {
					let date = new Date(),
						year = date.getFullYear(), //获取完整的年份(4位)
						month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
						strDate = date.getDate() // 获取当前日(1-31)
					if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
					if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
					return `${year}年${month}月${strDate}日`
				}
			}

		}
	}
</script>

<style scoped>
	
	.color {
		width: 100%;
		border: 1px solid #ff0000;
		/* background-color: red; */
		height: 640px;
	}

	.headboxdeom {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000128;
	}

	/* 总页面样式 */
	.head {
		margin: 0 auto;
		padding: 0 20px;
		/* border: 1px solid #ff0000; */
		background: url('../assets/beijingimg.png') no-repeat;
	}

	.headbody {
		width: 100%;
		height: 100%;
	}

	/* 上下部分总样式 */
	.upper {
		width: 1835px;
		height: 160px;
		padding: 30px 0 0 0;
		position: relative;
		background-size: contain;
		/* border: 1px solid #00ff7f; */
		background: url('../assets/tieliepng.png') no-repeat center;
	}

	.lower {
		width: 1835px;
		height: 870px;
		/* border: 1px solid #00ff7f; */
	}

	.container {
		width: 100%;
		height: 870px;
		/* border: 1px solid #ffff00; */
	}

	.containerone {
		width: 100%;
		height: 260px;
		/* border: 1px solid #ffffff; */
		background: url('../assets/buleimg.png') no-repeat top;
		background-size: 100% 240px;
	}

	.containertwo {
		width: 100%;
		height: 220px;
		/* border: 1px solid #ffffff; */
	}

	.containerthree {
		width: 100%;
		height: 225px;
		/* border: 1px solid #ffffff; */
	}

	.containerfour {
		width: 100%;
		height: 155px;
		color: #ffffff;
		/* border: 1px solid #ffffff; */
	}

	.middle {
		width: 100%;
		height: 870px;
		/* border: 1px solid #ffff00; */
	}

	/* 
	.middleone {
		width: 100%;
		height: 640px;
		background: url('../assets/map.png') no-repeat center;
		background-size: 100% 100%;
		z-index: 999;
		transform: scale(1);
		display: inline-block;
	} */
	#lBox {
		width: 100%;
		height: 640px;
		/* border: 1px solid transparent; */
		background: url('../assets/map.png') no-repeat center;
		background-size: 100% 100%;
		transform: scale(1);
		display: inline-block;
	}

	.contanier {
		position: absolute;
		width: 730px;
		height: 640px;
		/* border: 1px solid transparent; */
		background: url('../assets/map.png') no-repeat center;
		background-size: 100% 100%;
		transform: scale(1);
		display: inline-block;
	}

	.middletwo {
		width: 80%;
		height: 230px;
		margin-left: 10%;
		/* border: 1px solid #ffffff; */
	}

	.rightbox {
		width: 100%;
		height: 870px;
		/* border: 1px solid #ffff00; */
	}

	.rightone {
		width: 100%;
		height: 150px;
		/* border: 1px solid #ffffff; */
	}

	.righttwo {
		width: 100%;
		height: 300px;
		/* border: 1px solid #ffffff; */
	}

	.rightthree {
		width: 100%;
		height: 190px;
		/* border: 1px solid #ffffff; */
	}

	.rightfour {
		width: 100%;
		height: 230px;
		/* border: 1px solid #ffffff; */
	}

	/* 分样式 */
	.title {

		width: 100%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
	}

	.titlelift {
		width: 95%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
		z-index: 999
	}

	.titlerright {
		margin-left: 5%;
		width: 95%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
	}

	.ioc {
		width: 100%;
		height: 30px;
		background: url('../assets/ioc.png') no-repeat center;
	}

	.textup {
		width: 100%;
		height: 23px;
		font-size: 20px;
		font-weight: 600;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.textupcorl {
		width: 18%;
		font-size: 20px;
		line-height: 30px;
		font-weight: 600;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.textsunzi {
		width: 100%;
		font-size: 18px;
		font-weight: 600;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	
	.textdw {
		width: 100%;
		height: 20px;
		font-size: 14px;
		font-weight: 550;
		line-height: 26px;
		/* border: 1px solid #aa0000; */
		/* background-color: red; */
	}

	.leveliocbox {
		width: 100%;
		height: 84px;
		display: flex;
		/* background-color: red; */
	}

	.leveliocboxone {
		margin-top: 14px;
		width: 100%;
		height: 100px;
		display: flex;
		/* background-color: red; */
	}

	.levelioc {
		width: 20%;
		height: 90px;
		color: #ffffff;
		margin-top: 4px;
		text-align: center;
		/* border: 1px solid #aa0000; */
		background: url('../assets/organization.png') no-repeat center;
		/* background-size: cover; */
		background-size: 6vh;
	}

	.leveCarousel {
		width: 20%;
		height: 100px;
		/* border: 1px solid #aa0000; */
		display: flex;
		justify-content: center;
		/* background-size: cover; */

	}

	.maplikebox {
		width: 100%;
		height: 100%;
		/* border: 1px solid #aa0000; */
	}

	.mapliftbox {
		width: 100%;
		height: 640px;
		/* border: 10px solid red; */
	}

	.maprightbox {
		margin-left: 8%;
		margin-top: 140px;
		width: 10%;
		height: 40px;
		/* border: 1px solid red; */
		display: flex;
		justify-content: center;

	}

	.boxmapppr {
		width: 100%;
		height: 40px;
		/* border: 1px solid red; */
	}

	.tieletext {
		width: 100%;
		height: 30px;
		font-size: 19px;
		font-weight: 550;
		line-height: 30px;
		background-image: -webkit-linear-gradient(bottom, #A3D6FF, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.tieletextonelok {
		width: 70%;
		height: 30px;
		font-size: 19px;
		font-weight: 550;
		line-height: 30px;
		background-image: -webkit-linear-gradient(bottom, #A3D6FF, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.tieletextcol {
		width: 40%;
		height: 30px;
		font-size: 19px;
		font-weight: 550;
		line-height: 30px;
		background-image: -webkit-linear-gradient(bottom, #A3D6FF, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.subtitle {
		width: 100%;
		height: 30px;
		color: #00EAFF;
		font-size: 14px;
		font-weight: 550;
		line-height: 30px;
		text-align: right;
		padding: 0 20px;
	}

	.time {
		width: 40%;
		height: 88px;
		color: #ffffff;
		font-size: 20px;
		margin-left: 5%;
		margin-top: 60px;
		line-height: 40px;
		/* border: 1px solid #aa0000; */
	}

	.button {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-top: 70px;
		margin-left: 55%;
		line-height: 40px;
		display: flex;
		justify-content: center;
		/* border: 1px solid #aa0000; */
	}

	.rotationtable {
		margin-top: 12px;
		width: 100%;
		height: 140px;
		/* border: 1px solid #aa0000; */
	}

	.rotationtiele {
		padding: 0 10px;
		width: 100%;
		height: 30px;
		color: #00EAFF;
		font-size: 15px;
		font-weight: 550;
	}

	.typeimg {
		display: flex;
		justify-content: left;
		width: 100%;
		height: 65px;
	}

	.typeimgright {
		display: flex;
		justify-content: right;
		width: 100%;
		height: 90px;
		/* border: 1px solid #aa0000; */
	}

	.typeimgcss {
		padding: 0px 0 0 0;
		width: 90%;
		height: 100%;
		/* border: 1px solid #aa0000; */
	}

	.textone {
		/* border: 1px solid #aa0000; */
		margin-left: 4px;
		color: #00EAFF;
		text-align: left;
		font-weight: 700;
		letter-spacing: 1px;
		font-size: 16px;
		height: 30px;
		line-height: 60px;
	}

	.texttwo {
		/* color: #00EAFF; */
		font-size: 26px;
		font-weight: 600;
		height: 44px;
		/* border: 1px solid #aa0000; */
		line-height: 56px;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.focuscss {
		display: flex;
		height: 40px;
	}

	.schedule {
		margin-left: 10px;
		margin-top: 16px;
		width: 56%;
		height: 44px;
	}

	.rightimg {
		width: 100%;
		height: 110px;
		display: flex;
		/* border: 1px solid #aa0000; */
	}

	.imgboxone {
		margin-top: 15px;
		width: 50%;
		height: 80px;
		/* border: 1px solid #ffff00; */
		background: url('../assets/jianyi.png') no-repeat center;
	}

	.imgboxtwo {
		/* margin-left: 4%; */
		margin-top: 15px;
		width: 50%;
		height: 80px;
		/* border: 1px solid #ff5500; */
		background: url('../assets/lvzhi.png') no-repeat center;
	}

	.yian {
		width: 100%;
		height: 80px;
		line-height: 80px;
		font-size: 15px;
		font-weight: 600;
		color: #ffffff;
	}

	.yiansiz {
		width: 100%;
		height: 80px;
		color: #ffffff;
		font-size: 20px;
		font-weight: 600;
		line-height: 78px;
		padding: 0 0 0 5px;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.congress {
		width: 90%;
		height: 44px;
		color: #ffffff;
		font-size: 16px;
		margin-top: 10%;
		margin-left: 3%;
		font-weight: 600;
		line-height: 44px;
		border-radius: 6px;
		display: flex;
		padding: 0 0 0 8px;
		background: url('../assets/conioc.png') no-repeat center;
	}

	.congresstextone {

		width: 90%;
		height: 44px;
		color: #ffffff;
		font-size: 16px;
		margin-left: 15%;
		font-weight: 600;
		line-height: 44px;
		border-radius: 6px;
		display: flex;
	}

	.congresstext {
		font-size: 20px;
		text-indent: 1vh;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;

	}

	.congressbox {
		width: 54%;
		height: 44px;
		margin-top: 3%;
		margin-left: 23%;
		border-radius: 6px;
		background: url('../assets/conioc.png') no-repeat center;
		background-size: cover;

	}

	.boxbig {
		width: 100%;
		height: 40px;
	}

	.tuli {
		width: 100%;
		height: 34px;
		background: url('../assets/tuli.png') no-repeat center;
		background-size: 100% 90%;
		/* border: 1px solid red; */
	}

	.boxzhuanjiasiz {
		height: 48px;
		line-height: 40px;
		font-size: 30px;
		background-image: -webkit-linear-gradient(bottom, #55ffff, #ffffff, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-weight: 800;
	}

	.boxdaibiao {
		height: 42px;
		font-size: 34px;
		margin-top: -14px;
		text-align: center;
		background-image: -webkit-linear-gradient(bottom, #55ffff, #ffffff, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-weight: 800;
	}

	.boximgdbrs {
		/* border: 1px solid red; */
		width: 36%;
		height: 75px;
		margin-left: 50%;
		margin-top: 20px;
		background: url('../assets/dbrs.png') no-repeat center;
	}

	.mapcss {
		width: 190px;
		bottom: 270px;
		z-index: 999;
		position: absolute;
		margin-left: 550px;
		/* border: 1px solid red; */
	}

	.mapstit {
		position: absolute;
	}

	.mapsimg {
		width: 390px;
		height: 60px;
		bottom: 800px;
		z-index: 999;
		/* border: 1px solid red; */
		position: absolute;
		margin-left: 550px;
		background: url('../assets/quanguocheng.png') no-repeat center;
		background-size: 100% 100%;
	}

	.middleboxone {
		width: 730px;
		height: 640px;
		overflow: hidden;
		position: relative;
		margin-left: 92.5px;
	}

	/* 修改datav组件样式 */
	/deep/.dv-scroll-board .rows .row-item {
		border-radius: 4px;

	}

	/* 	/deep/.row-item {
		background-color: aqua;
	} */

	.ceil {
		font-size: 14px;
	}

	.boximg {
		width: 150px;
		height: 100%;
		padding: 20px 20px 0 20px;
		line-height: 30px;
		color: #fff;
		font-size: 16px;
		background: url('../assets/透明框1.png') no-repeat center;
		background-size: 100% 100%;
	}

	/deep/.el-progress-bar__outer {
		background-color: #004f93 !important
	}

	/deep/.el-progress-bar__inner {
		background-color: #06c1ed !important;
	}

	/deep/.el-progress-bar__innerText {
		font-size: 18px !important;
		color: #ffffff !important;
	}

	.leveCarousel /deep/ .dv-scroll-board .rows .ceil {
		padding: 0;
		text-align: center;
	}

	.boxhmss /deep/ .dv-scroll-board .rows .ceil {
		padding: 0 0 0 12px;
	}

	.title /deep/ .dv-scroll-board .rows .ceil {
		padding: 0 0 0 12px;
	}
</style>